import { z } from 'zod';

// Enum for generation status
export const GenerationStatusEnum = z.enum([
  'NO_GENERATION',
  'GENERATING',
  'READY_TO_REVIEW',
  'REVIEWED',
  'GENERATION_ERROR',
  'READY_TO_GENERATE'
]);

export type GenerationStatus = z.infer<typeof GenerationStatusEnum>;

// Schema for ContentGenerationRecord
export const ContentGenerationRecordSchema = z.object({
  stacklineSku: z.string(),
  status: GenerationStatusEnum,
  updatedAt: z.string(), // DateTime comes as string from API
  profileId: z.string(),
  profileName: z.string(),
  totalRetailSales: z.number(),
  version: z.number(),
  skuContentGenerationId: z.string().optional(),
  profileVersion: z.number(),
  projectId: z.string().optional()
});

export interface ContentGenerationRecord {
  stacklineSku: string;
  updatedAt: string;
  version: number;
  profileId: string;
  profileName: string;
  retailerSku: string;
  status: GenerationStatus;
  checked?: boolean;
  profileVersion: number;
  totalRetailSales: number;
  product?: GetEntityMetadataResponseRecord;
  categoryId?: number;
  subCategoryId?: number;
  contentUrl?: string;
  skuContentGenerationId?: string;
  projectId?: string;
}

// Schema for GetContentGenerationResponse
export const GetContentGenerationResponseSchema = z.object({
  records: z.array(ContentGenerationRecordSchema),
  totalCount: z.number()
});

export type GetContentGenerationResponse = z.infer<typeof GetContentGenerationResponseSchema>;

export interface GetEntityMetadataResponseRecord {
  id: string;
  title: string;
  subtitle: string;
  translatedTitles: string;
  brandName: string;
  brandId: number;
  categoryName: string;
  categoryId: number;
  profileVersion: number;
  subCategoryName: string;
  subCategoryId: number;
  retailerSku: string;
  stacklineSku: string;
  upc: string;
}
